// Acknowledge an active alert (L4.2): shown only to roles that may (ed_coordinator; the API
// checks again with can()). It stops further escalation of this level. The alert stays on the
// board, with the row colour it had.

import type { BoardTimer } from '@diagnuvo/domain';
import { useState } from 'react';
import { acknowledgeAlert, AlertChanged } from '../api.ts';

export function AcknowledgeButton({
  siteId,
  encounterId,
  timer,
  onDone,
}: {
  siteId: string;
  encounterId: string;
  timer: BoardTimer;
  onDone?: () => void;
}) {
  const [state, setState] = useState<'idle' | 'sending' | 'done' | 'changed' | 'failed'>('idle');
  if (timer.alert === 'none' || timer.acknowledgedAt !== undefined) return null;
  if (state === 'done') return <span className="ack-note">Acknowledged</span>;
  const send = () => {
    setState('sending');
    acknowledgeAlert(siteId, encounterId, timer).then(
      () => {
        setState('done');
        onDone?.();
      },
      (error: unknown) => setState(error instanceof AlertChanged ? 'changed' : 'failed'),
    );
  };
  return (
    <span className="ack">
      <button type="button" className="btn btn-ack" disabled={state === 'sending'} onClick={send}>
        {state === 'sending' ? 'Acknowledging…' : `Acknowledge ${timer.alert}`}
      </button>
      {state === 'changed' && (
        <span className="ack-error" role="alert">
          The alert changed. Check it again.
        </span>
      )}
      {state === 'failed' && (
        <span className="ack-error" role="alert">
          Not saved. Try again.
        </span>
      )}
    </span>
  );
}
